var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 分享相关逻辑
 */
import { isWeChat, isQQ, isQzone, isPitu } from '@tencent/h5-env-enhance';
import { getQQVersion, pageLoadScript } from '../utill';
import { MaskImage, MqzoneJS, QQJS, QQShuoshuoBridge, WechatBridge, WechatJS } from './common';
/*************** 分享参数 *****************/
/**
 * 设置微信分享参数
 * @param shareInfo 分享参数
 */
var setWxShareInfo = function (shareInfo) {
    var wx = window.wx;
    wx.onMenuShareTimeline(shareInfo);
    wx.onMenuShareAppMessage(shareInfo);
    wx.onMenuShareQQ(shareInfo);
    wx.onMenuShareWeibo(shareInfo);
    wx.onMenuShareQZone(shareInfo);
};
/**
 * 获取微信分享参数
 * @param shareInfo 分享参数
 */
var getWxShareInfo = function (shareInfo) {
    var title = shareInfo.title, description = shareInfo.description, link = shareInfo.link, imgUrl = shareInfo.imgUrl;
    return {
        title: title,
        desc: description,
        link: link,
        imgUrl: imgUrl,
        success: function () { },
        cancel: function () { },
    };
};
/**
 * 获取QQ空间分享参数
 * @param shareInfo 分享参数
 */
var getMqzoneShareInfo = function (shareInfo) {
    var title = shareInfo.title, description = shareInfo.description, link = shareInfo.link, imgUrl = shareInfo.imgUrl;
    return {
        type: 'share',
        image: [imgUrl, imgUrl, imgUrl, imgUrl, imgUrl],
        summary: [title, title, title, title, title],
        title: [description, description, description, description, description],
        shareUrl: [link, link, link, link, link],
    };
};
/**
 * 获取手Q分享参数
 * @param shareInfo 分享参数
 */
var getQQShareInfo = function (shareInfo) {
    var title = shareInfo.title, description = shareInfo.description, link = shareInfo.link, imgUrl = shareInfo.imgUrl, sourceName = shareInfo.sourceName, _a = shareInfo.back, back = _a === void 0 ? false : _a;
    return {
        title: title,
        share_url: link,
        desc: description,
        image_url: imgUrl,
        source_name: sourceName,
        back: back,
    };
};
/**
 *  初始化微信分享参数
 * @param shareInfo 分享参数
 */
var setWxShareConfig = function (shareInfo) {
    var wx = window.wx;
    var wxShareInfo = getWxShareInfo(shareInfo);
    if (typeof wx === 'object') {
        setWxShareInfo(wxShareInfo);
    }
    else {
        pageLoadScript(WechatJS, function () {
            pageLoadScript(WechatBridge, function () {
                window.wx.ready(function () {
                    setWxShareInfo(wxShareInfo);
                });
            });
        });
    }
};
/**
 * 初始化手Q分享参数
 * @param shareInfo 分享参数
 */
var setMqqShareConfig = function (shareInfo) {
    var qqShareInfo = getQQShareInfo(shareInfo);
    var mqq = window.mqq;
    if (typeof mqq === 'object') {
        mqq.data.setShareInfo(qqShareInfo);
        mqq.ui.setOnShareHandler(function (shareType) {
            mqq.ui.shareMessage(__assign(__assign({}, qqShareInfo), { share_type: shareType, sourceName: qqShareInfo.source_name }));
        });
    }
    else {
        pageLoadScript(QQJS, function () {
            var mqq = window.mqq;
            mqq.data.setShareInfo(qqShareInfo);
            mqq.ui.setOnShareHandler(function (shareType) {
                mqq.ui.shareMessage(__assign(__assign({}, qqShareInfo), { share_type: shareType, sourceName: qqShareInfo.source_name }));
            });
        });
    }
};
/**
 * 初始化QQ空间分享参数
 * @param shareInfo 分享参数
 */
var setMqzoneShareConfig = function (shareInfo) {
    var mqzoneShareInfo = getMqzoneShareInfo(shareInfo);
    var QZAppExternal = window.QZAppExternal;
    if (typeof QZAppExternal === 'object') {
        QZAppExternal.setShare(function () { }, mqzoneShareInfo);
    }
    else {
        pageLoadScript(MqzoneJS, function () {
            window.QZAppExternal.setShare(function () { }, mqzoneShareInfo);
        });
    }
};
/**
 * 初始化分享参数
 * @param shareInfo 分享配置信息
 */
var initShare = function (shareInfo) {
    if (isWeChat()) {
        setWxShareConfig(shareInfo);
    }
    if (isQQ()) {
        setMqqShareConfig(shareInfo);
    }
    if (isQzone()) {
        setMqzoneShareConfig(shareInfo);
    }
    return;
};
/**
 * 更新分享参数
 */
var updateShareInfo = initShare;
/*************** 分享面板 *****************/
/**
 * 获取天天p图分享参数
 * @param shareInfo 分享参数
 */
var getPituShareInfo = function (shareInfo) {
    var title = shareInfo.title, description = shareInfo.description, link = shareInfo.link, imgUrl = shareInfo.imgUrl, imgData = shareInfo.imgData;
    var pituShareInfo = {
        title: title,
        desc: description,
        summary: '',
        url: link,
        platforms: 'QQImage,QzoneImage,WechatImage,MomentImage,SinaImage',
    };
    if (imgUrl) {
        pituShareInfo.imageUrl = imgUrl;
        pituShareInfo.originImageUrl = imgUrl;
    }
    if (imgData) {
        pituShareInfo.imgData = imgData;
    }
    return pituShareInfo;
};
/**
 * 唤起天天p图分享面板
 * @param shareInfo 分享参数配置信息
 */
var openPituSharePanel = function (shareInfo) {
    var PituBridge = window.PituBridge;
    var pituShareInfo = getPituShareInfo(shareInfo);
    PituBridge.share(pituShareInfo);
};
/**
 * 唤起qq说说面板
 * qq 版本大于 72 使用
 * @param shuoshuoInfo 说说分享信息
 */
var openQQshuoshuo = function (shuoshuoInfo) {
    var params = shuoshuoInfo;
    var commandSrc = "" + QQShuoshuoBridge + encodeURIComponent(JSON.stringify(params));
    location.href = commandSrc;
};
/**
 * 唤起qq分享面板
 */
var openQQSharePanel = function () {
    var mqq = window.mqq;
    mqq.invoke('ui', 'showShareMenu');
};
/**
 * 微信及其他环境中，显示全屏遮照图片
 */
var openPageMask = function () {
    if (document.getElementById('share_mask')) {
        document.getElementById('share_mask').style.display = 'block';
        return;
    }
    var $mask = document.createElement('div');
    var $imageIcon = document.createElement('img');
    $imageIcon.src = MaskImage;
    $imageIcon.style.cssText = 'width: 84%; position: absolute; right: 8%; top: 4%;';
    $mask.appendChild($imageIcon);
    $mask.id = 'share_mask';
    $mask.style.display = 'block';
    $mask.style.cssText = 'z-index: 99999; background: #000; position: fixed; top: 0; left: 0; opacity: .7; width: 100%; height: 100vh;';
    document.body.appendChild($mask);
    $mask.addEventListener('click', function () {
        $mask.style.display = 'none';
    });
};
/**
 * 打开分享面板： 包含qq, qq说说，天天p图，微信（显示遮罩）
 * @param sharePanelParams
 * @returns void
 */
var openSharePanel = function (sharePanelParams) {
    var shuoshuoInfo = sharePanelParams.shuoshuoInfo, pituShareInfo = sharePanelParams.pituShareInfo;
    if (isPitu()) {
        openPituSharePanel(pituShareInfo);
        return;
    }
    if (isQQ()) {
        // qq环境下, 如果配置了说说信息, 优先发说说
        if (getQQVersion() >= 72 && shuoshuoInfo) {
            openQQshuoshuo(shuoshuoInfo);
            return;
        }
        openQQSharePanel();
        return;
    }
    // 打开分享弹窗
    openPageMask();
};
export { initShare, updateShareInfo, setWxShareConfig, setMqqShareConfig, setMqzoneShareConfig, openSharePanel, };
